export default class Configure {
    constructor() {
        this.configureButton = $('.product-configure-button')
    }

    /**
     * Scroll to Product Config
     */
    scrollToConfig() {
        let windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
        let marginToTop
        if (windowWidth <= 640) {
            marginToTop = 80
        } else {
            marginToTop = 150
        }
        $('html, body').animate({ scrollTop: $('.product-config__basket').offset().top - marginToTop }, 500)
    }

    /**
     * Initialize class
     */
    init() {
        this.configureButton.on('click', () => this.scrollToConfig())
    }
}

